<template>
  <span class="th-wrapper" @mouseenter="onEnter" @mouseleave="onLeave" @focusin="onEnter" @focusout="onLeave">
    <slot />
    <transition name="th-fade">
      <div v-if="visible" class="th-bubble" :class="positionClass">
        <span class="th-text">{{ short }}</span>
        <transition name="th-fade">
          <router-link v-if="showMore && faqAnchor" :to="'/faq#' + faqAnchor" class="th-more" @click="onLeave">
            {{ moreLabelText }} →
          </router-link>
        </transition>
      </div>
    </transition>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    short: { type: String, required: true },
    faqAnchor: { type: String, default: '' },
    position: { type: String, default: 'top' },
  },
  data() {
    return {
      visible: false,
      showMore: false,
      enterTimer: null as any,
      moreTimer: null as any,
    };
  },
  computed: {
    positionClass(): string {
      return `th-bubble--${this.position}`;
    },
    moreLabelText(): string {
      return this.$store.getters.currentLanguage === 'en' ? 'See more' : 'Voir plus';
    },
  },
  methods: {
    onEnter() {
      this.enterTimer = setTimeout(() => {
        this.visible = true;
        this.moreTimer = setTimeout(() => {
          this.showMore = true;
        }, 2000);
      }, 300);
    },
    onLeave() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.moreTimer);
      this.visible = false;
      this.showMore = false;
    },
  },
});
</script>

<style>
.th-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.th-bubble {
  position: absolute;
  z-index: 9999;
  background: #1e2228;
  color: #f0f0f0;
  font-size: 0.78rem;
  line-height: 1.45;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  width: max-content;
  max-width: 220px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  white-space: normal;
}
.th-bubble a {
  pointer-events: auto;
}

.th-bubble--top {
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
}
.th-bubble--bottom {
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
}
.th-bubble--right {
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
}
.th-bubble--left {
  right: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
}

.th-more {
  display: block;
  margin-top: 0.35rem;
  color: #f28a16;
  font-weight: 600;
  font-size: 0.75rem;
  text-decoration: none;
}
.th-more:hover {
  color: #ffa040;
  text-decoration: underline;
}

.th-fade-enter-active,
.th-fade-leave-active {
  transition: opacity 0.15s;
}
.th-fade-enter,
.th-fade-leave-to {
  opacity: 0;
}
</style>
